import { nanoid } from 'nanoid'
import { logger } from 'shared/lib'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { ModalTypeList } from 'shared/ui/Modal/store/types'
import { toastStore } from 'shared/ui'
import { type IEntitiesStore } from 'entities/EntitiesExport'
import { SurveysApi } from 'entities/Surveys'
import { type IResponseGetSurvey } from 'entities/Surveys/api/types'
import { logDeactivateSurveyEvent } from 'pages/surveys/lib/logSurveyStatusEvents'

export const openDisableSurveyModal = (
  id: number,
  entities: IEntitiesStore,
  onSuccess: (data: IResponseGetSurvey) => void
): void => {
  const modalId = nanoid()

  const onClose = () => {
    modalStore.closeModal(modalId)
  }

  modalStore.addModal({
    type: ModalTypeList.ALERT,
    id: modalId,
    title: 'Disable survey?',
    desc: 'This will terminate all active Surveys sessions with enrolled contacts',
    width: 280,
    primaryAction: {
      text: 'Disable',
      onAction: async () => {
        try {
          const { data } = await SurveysApi.activateSurvey(id, { is_active: false })
          logDeactivateSurveyEvent(entities)
          onClose()
          onSuccess(data)
          toastStore.add({ type: 'success', title: 'Survey disabled' })
        } catch (error) {
          logger.error(error)
          onClose()
          toastStore.add({ title: 'Something went wrong', desc: 'Please try again', type: 'error' })
        }
      },
    },
    secondaryAction: {
      text: 'Cancel',
      onAction: onClose,
    },
  })
}
